/* 中文词典：settings 命名空间。见 src/i18n/README.md。 */

import type { TextSpec } from '../text';

const settings = {
  'settings.section.language': [ '语言' ],
  'settings.languageNote': [ '切换后立即生效。首次进入跟随浏览器语言。' ],
  'settings.section.gamepad': [ '手柄' ],
  'settings.gamepadNintendo': [ '任天堂布局' ],
  'settings.gamepadXbox': [ 'XBox 布局' ],
  'settings.gamepadNote': [ '交换 A/B 与 X/Y 的物理位置（动作始终绑在字母上）。默认任天堂：A 在右、B 在下。' ],
  'settings.section.audio': [ '声音' ],
  'settings.bgmVolume': [ 'BGM 音量' ],
  'settings.sfxVolume': [ '音效音量' ],
  'settings.section.interface': [ '界面' ],
  'settings.uiScale': [ 'UI 大小' ],
  'settings.uiScaleNote': [ 'UI 倍率暂未实现。' ],
  'settings.section.lore': [ '卡牌说明' ],
  'settings.loreNote': [ '选择悬停卡牌时显示的板块。无效卡的「功能：一对」等连击条目跟随「功能」。' ],
  'settings.section.save': [ '存档' ],
  'settings.export': [ '导出设置' ],
  'settings.exported': [ '已导出设置' ],
  'settings.exportFailed': [ '导出失败：', { type: 'param', name: 'reason' } ],
  'settings.resetDone': [ '已恢复默认设置' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
settings satisfies Record<string, TextSpec>;
export default settings;
